'use strict';

var SeasonCustomRendererFactory = function SeasonCustomRendererFactory(seasonColorService) {
  function seasonRenderer(columnContext, row, columnField, value, defaultValue) {
    var color = seasonColorService.isSeason(value) && seasonColorService.getColor(value);
    if (color) {
      return defaultValue.replace('class="jqx-grid-cell-middle-align"', 'class="jqx-grid-cell-middle-align colored-season" style="background-color: ' + color + '"');
    }
    return defaultValue;
  }
  return {
    season: seasonRenderer
  };
};
SeasonCustomRendererFactory.$inject = ['SeasonColorService'];
module.exports = SeasonCustomRendererFactory;